import { useEffect, useState } from "react";
import { useI18n } from "../i18n";
import { SunIcon, MoonIcon } from "./icons";

type Theme = "famflix-light" | "famflix-dark";

// The inline boot script in index.html already resolves the theme (stored
// value incl. legacy names, else system preference) and applies it to <html>
// before first paint. Read that as the source of truth so the logic lives in
// one place.
function getInitialTheme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "famflix-dark"
    ? "famflix-dark"
    : "famflix-light";
}

export default function ThemeToggle() {
  const { t } = useI18n();
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const isLight = theme === "famflix-light";
  const toggleTheme = () =>
    setTheme(isLight ? "famflix-dark" : "famflix-light");

  return (
    <button
      className="btn btn-ghost btn-circle btn-sm"
      onClick={toggleTheme}
      aria-label={isLight ? t("theme.toDark") : t("theme.toLight")}
    >
      {isLight ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
